import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';


/* Screens Import */
import LanguageSelect from '../../CommonScreens/LanguageSelect/LanguageSelect';
import NameAndEmail from '../../CommonScreens/NameAndEmail/NameAndEmail';
import WelcomeScreen from '../../CommonScreens/WelcomeScreen/WelcomeScree';
import Frame1 from '../../Episode1/Frame1/Frame1';
import Frame2 from '../../Episode1/Frame2/Frame2';
import Frame3 from '../../Episode1/Frame3/Frame3';
import Frame4 from '../../Episode1/Frame4/Frame4';
import Frame5 from '../../Episode1/Frame5/Frame5';
import Frame6 from '../../Episode1/Frame6/Frame6';
import Frame7 from '../../Episode1/Frame7/Frame7';
import Frame8 from '../../Episode1/Frame8/Frame8';
import Frame9 from '../../Episode1/Frame9/Frame9';
import Frame10 from '../../Episode1/Frame10/Frame10';
import Frame11 from '../../Episode1/Frame11/Frame11';
import Frame12 from '../../Episode1/Frame12/Frame12';
import Frame13 from '../../Episode1/Frame13/Frame13';
import Frame14 from '../../Episode1/Frame14/Frame14';
import Frame15 from '../../Episode1/Frame15/Frame15';
import Frame16 from '../../Episode1/Frame16/Frame16';
import Frame17 from '../../Episode1/Frame17/Frame17';
import Frame18 from '../../Episode1/Frame18/Frame18';
import Frame19 from '../../Episode1/Frame19/Frame19';
import Frame20 from '../../Episode1/Frame20/Frame20';
import Frame21 from '../../Episode1/Frame21/Frame21';
import Frame22 from '../../Episode1/Frame22/Frame22';
import Frame23 from '../../Episode1/Frame23/Frame23';

function Episode1_MainPage() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);

    if (pageNo === 3) {
        return (
            <div>
                <WelcomeScreen />
            </div>
        )
    } else if (pageNo === 4) {
        return (
            <div>
                <Frame1 />
            </div>
        )
    } else if (pageNo === 5) {
        return (
            <div>
                <Frame2 />
            </div>
        )
    } else if (pageNo === 6) {
        return (
            <div>
                <Frame3 />
            </div>
        )
    } else if (pageNo === 7) {
        return (
            <div>
                <Frame4 />
            </div>
        )
    } else if (pageNo === 8) {
        return (
            <div>
                <Frame5 />
            </div>
        )
    } else if (pageNo === 9) {
        return (
            <div>
                <Frame6 />
            </div>
        )
    } else if (pageNo === 10) {
        return (
            <div>
                <Frame7 />
            </div>
        )
    } else if (pageNo === 11) {
        return (
            <div>
                <Frame8 />
            </div>
        )
    } else if (pageNo === 12) {
        return (
            <div>
                <Frame9 />
            </div>
        )
    } else if (pageNo === 13) {
        return (
            <div>
                <Frame10 />
            </div>
        )
    } else if (pageNo === 14) {
        return (
            <div>
                <Frame11 />
            </div>
        )
    } else if (pageNo === 15) {
        return (
            <div>
                <Frame12 />
            </div>
        )
    } else if (pageNo === 16) {
        return (
            <div>
                <Frame13 />
            </div>
        )
    } else if (pageNo === 17) {
        return (
            <div>
                <Frame14 />
            </div>
        )
    } else if (pageNo === 18) {
        return (
            <div>
                <Frame15 />
            </div>
        )
    } else if (pageNo === 19) {
        return (
            <div>
                <Frame16 />
            </div>
        )
    } else if (pageNo === 20) {
        return (
            <div>
                <Frame17 />
            </div>
        )
    } else if (pageNo === 21) {
        return (
            <div>
                <Frame18 />
            </div>
        )
    } else if (pageNo === 22) {
        return (
            <div>
                <Frame19 />
            </div>
        )
    } else if (pageNo === 23) {
        return (
            <div>
                <Frame20 />
            </div>
        )
    } else if (pageNo === 24) {
        return (
            <div>
                <Frame21 />
            </div>
        )
    } else if (pageNo === 25) {
        return (
            <div>
                <Frame22 />
            </div>
        )
    } else if (pageNo === 26) {
        return (
            <div>
                <Frame23 />
            </div>
        )
    }
}

export default Episode1_MainPage